"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("../../../node_modules/graphql-tag/lib/index.js").gql`
    mutation updatePasswordService($email: String!, $clientId: String!) {
        MyHomeAccount {
            Password(
                changePasswordRequestInput: {
                    clientId: $clientId
                    email: $email
                }
            )
        }
    }
`;exports.updatePassword=e;
//# sourceMappingURL=queries.js.map
